import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class DealerProfileTagsListRatingsValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static validate({value}) {
    const isArray = Array.isArray(value)

    if (!isArray) {
      throw InvalidParamsSharedError.create(
        `[DealerProfileTagsListRatingsValueObject.validate] tags(${value}) should be an array`
      )
    }

    const hasTags = Boolean(value.length)
    const allTagsAreStrings = value.every(tag => typeof tag === 'string')

    if (hasTags && !allTagsAreStrings) {
      throw InvalidParamsSharedError.create(
        `[DealerProfileTagsListRatingsValueObject.validate] every tag should be a string`
      )
    }
  }

  static createFromPrimitives({value}) {
    DealerProfileTagsListRatingsValueObject.validate({value})
    return new DealerProfileTagsListRatingsValueObject({value})
  }

  get value() {
    return this.#value
  }

  toJSON() {
    return {value: this.#value}
  }
}
